import { FromInstalled, FromIPhone, FromGameApp, FromStandAlone } from "@/utils/BroswerHelper";
import { LocalConfig } from "../config";
import { SendCMD } from "@/utils/HTTPRequest";
import { DeepEqual } from "@/utils/JSTool";
import { createContext, useEffect, useState } from "react";

const defaultPersist = {
  dataLoaded: false,
  debug: false,
  language: "ar",
  location: "KE",
  downloadTipClosed: FromInstalled || FromIPhone,
  invitePromotionOpenDay: -1,
  funnelStepsFinishAt: {},
  funnelStepsUploadedAt: 0,
};

// 创建一个 Context
export const PersistContext = createContext(defaultPersist);

let untrackedData = defaultPersist;

// 创建一个 DataProvider 组件
export const PersistProvider = ({ children }) => {
  const [data, setData] = useState(untrackedData);
  const [expires, setExpires] = useState({});
  const [hideBottomNav, setHideBottomNav] = useState(untrackedData.hideBottomNav || false);
  useEffect(() => {
    loadPersistDataOnce();
  }, []);
  const reloadUserInfo = (token) => {
    if (token || (data.user_info && data.user_info.token)) {
      const requestedToken = token || data.user_info.token;
      //登录请求
      let platform = "1";
      if (FromGameApp) {
        platform = "2";
      }
      if (FromStandAlone) {
        platform = "3";
      }
      SendCMD("getMe", {
        plat: platform,
        token: requestedToken,
      }).then((res) => {
        // A pending getMe for a guest or previous account must not replace a newly registered account.
        if (!untrackedData.user_info || untrackedData.user_info.token !== requestedToken) return;
        if (!res.status) {
          //账号过期清空账号
          console.log(res.errdesc);
          setPersist("user_info", null);
          setPersist("gatesvr", null);
        } else {
          console.log(res.player_info);
          if (res.player_info) {
            setPersist("user_info", res.player_info);
            setPersist("gatesvr", res.gatesvr);
          }
        }
        console.log(res);
      });
    }
  };

  const loadPersistDataOnce = () => {
    if (untrackedData.dataLoaded) {
      return;
    }
    let persistStr = localStorage.getItem("persist");
    console.log("persistStr loaded:", persistStr);
    if (persistStr) {
      try {
        let persistData = JSON.parse(persistStr);
        for (let key in persistData) {
          if (typeof persistData[key] == "undefined" || persistData[key] == null) {
            delete persistData[key];
          }
        }
        untrackedData = Object.assign({}, untrackedData, persistData);
      } catch (e) {
        console.error(e);
      }
    }
    let expiresStr = localStorage.getItem("expires");
    if (expiresStr) {
      try {
        let expires = JSON.parse(expiresStr);
        setExpires(expires);
      } catch (e) {
        console.error(e);
      }
    }
    untrackedData.dataLoaded = true;
    setData(Object.assign({}, untrackedData));
    if (untrackedData.user_info && untrackedData.user_info.token) {
      reloadUserInfo(untrackedData.user_info.token);
    }
  };

  const setPersist = (key, value, expireSeconds) => {
    console.log("setPersist", key, expireSeconds);
    loadPersistDataOnce();
    if (DeepEqual(untrackedData[key], value)) return;
    untrackedData[key] = value;
    if (expireSeconds && expireSeconds > 0) {
      let expireData = { ...expires };
      expireData[key] = Date.now() + expireSeconds * 1000;
      setExpires(expireData);
      localStorage.setItem("expires", JSON.stringify(expireData));
    }
    if (key === "hideBottomNav") {
      setHideBottomNav(value);
    }
    setData(() => Object.assign({}, untrackedData));
    localStorage.setItem("persist", JSON.stringify(untrackedData));
  };

  const getPersist = (key) => {
    loadPersistDataOnce();
    let value = data[key];
    if (typeof value == "undefined") return null;
    let keyExpire = expires[key];
    if (keyExpire && keyExpire < Date.now()) {
      let dataTmp = { ...data };
      delete dataTmp[key];
      delete untrackedData[key];
      let expiresTmp = { ...expires };
      delete expiresTmp[key];
      localStorage.setItem("persist", JSON.stringify(dataTmp));
      localStorage.setItem("expires", JSON.stringify(expiresTmp));
      return null;
    }
    return value;
  };

  // Async recharge callbacks need the latest value, rather than a render snapshot.
  const getPersistLatest = (key) => {
    loadPersistDataOnce();
    const keyExpire = expires[key];
    if (keyExpire && keyExpire < Date.now()) return getPersist(key);
    const value = untrackedData[key];
    return typeof value === "undefined" ? null : value;
  };

  const updatePersist = (key, updater) => {
    loadPersistDataOnce();
    const next = updater(untrackedData[key]);
    setPersist(key, next);
    return next;
  };

  return (
    <PersistContext.Provider value={{ getPersist, getPersistLatest, setPersist, updatePersist, reloadUserInfo, hideBottomNav }}>
      {children}
    </PersistContext.Provider>
  );
};
